import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Header } from 'semantic-ui-react';
import Location from '../../../../molecules/Location';
import SiteMap from '../../../../molecules/SiteMap';
import HoursOfOperation from '../../../../molecules/HoursOfOperation';

import './site-footer-body.css';

const SimpleBody = props => {
  const {
    contactInformation,
    pages,
    hours,
    bodyColor,
    locationClassName,
    hoursClassName,
    pagesClassName,
  } = props;

  const contactInfoColumns = contactInformation !== null ? 3 : 0;
  const hoursColumns = hours.length !== 0 ? 3 : 0;
  const infoColumns = contactInfoColumns + hoursColumns > 0 ? 3 : 0;
  const pageColumns = 2;

  const InfoColumn = () =>
    infoColumns < 3 ? null : (
      <Grid.Column
        computer={infoColumns}
        tablet={infoColumns * 2}
        mobile={16}
        floated="right"
        textAlign="center"
      >
        <Header as="h4" className="site-footer-body-header">
          Contact Information
        </Header>
        <Location
          address={contactInformation.address}
          showIcon={false}
          className={locationClassName}
        />
        {hours && <br />}
        {hours && <br />}
        {hours && (
          <HoursOfOperation hours={hours} displayOption="grouped" className={hoursClassName} />
        )}
      </Grid.Column>
    );

  const PagesColumn = () =>
    pages.map(page => (
      <React.Fragment key={`footer-page-${page.title}`}>
        <Grid.Column mobile={3} only="mobile" />
        <Grid.Column
          className={pagesClassName}
          computer={pageColumns}
          tablet={pageColumns}
          verticalAlign="top"
          only="computer tablet"
        >
          <Header as="h4" className="site-footer-body-header">
            {page.title}
          </Header>
          <SiteMap title={page.title} links={page.pages} />
        </Grid.Column>
        <Grid.Column
          className={pagesClassName}
          mobile={10}
          verticalAlign="middle"
          textAlign="center"
          only="mobile"
        >
          <Header as="h4">{page.title}</Header>
          <SiteMap links={page.pages} />
        </Grid.Column>
        <Grid.Column computer={1} tablet={1} mobile={3} />
      </React.Fragment>
    ));

  return (
    <div style={{ backgroundColor: bodyColor, paddingTop: '3em', paddingBottom: '2em' }}>
      <Grid>
        <Grid.Column computer={1} tablet={1} only="computer" />
        <PagesColumn />
        <InfoColumn />
        <Grid.Column computer={1} only="computer" />
      </Grid>
    </div>
  );
};

SimpleBody.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        pageTitle: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        internal: PropTypes.bool.isRequired,
      }),
    ),
  ).isRequired,
  contactInformation: PropTypes.shape({
    address: PropTypes.shape({
      street: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zip: PropTypes.string.isRequired,
    }),
    phoneNumber: PropTypes.string.isRequired,
    email: PropTypes.string,
  }),
  bodyColor: PropTypes.string.isRequired,
  locationClassName: PropTypes.string,
  hoursClassName: PropTypes.string,
  pagesClassName: PropTypes.string,
  hours: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.number.isRequired,
      open: PropTypes.number.isRequired,
      close: PropTypes.number.isRequired,
      label: PropTypes.string,
    }),
  ),
};

SimpleBody.defaultProps = {
  contactInformation: null,
  hours: null,
  locationClassName: 'footer-location-info',
  hoursClassName: 'footer-hoo',
  pagesClassName: 'footer-pages',
};

export default SimpleBody;
